// import socketIoClient from "socket.io-client";

// import { get } from "./cookies";

// let socket;

// export const connectMainIo = () => {
//   socket = socketIoClient(process.env.REACT_APP_API_ACCOUNT_URL);

//   socket.on("connect_error", err => {});

//   socket.on("connect", () => {
//     socket.emit("SiteSocket", {
//       token: get("token"),
//       site_id: 8,
//     });
//   });
// };

// NEW SOCKET

import { useSelector } from "react-redux";
import { io } from "socket.io-client";
import UserAgent from "user-agents";
import { get } from "./cookies";

const userAgent = new UserAgent();

// const user_id = JSON.parse(localStorage.getItem('authUser'))
// const { user } = useSelector((state) => state.auth); //,user,token
// console.log("here", user)
const user = get("user");

// if (user === null) {
//   fetchProfile;
// } else {wss://api.analytics.stuffyoucanuse.dev/socket.io/?app=1&EIO=4&transport=websocket
const socket = io(`wss://api.analytics.stuffyoucanuse.org?app=8`, {
  transports: ["websocket", "polling", "flashsocket"],
});
// }
const network = get("remote_info");
const ip = get("remote_ip");

let Obj = {
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  userAgent: JSON.stringify(userAgent.data),
  screen: {
    availHeight: window.screen.availHeight,
    availWidth: window.screen.availWidth,
    colorDepth: window.screen.colorDepth,
    height: window.screen.height,
    pixelDepth: window.screen.pixelDepth,
    width: window.screen.width,
  },
  vendor: window.navigator.vendor,
  platform: window.navigator.platform,
  deviceMemory: window.navigator.deviceMemory,
  languages: window.navigator.languages,
  network: null,
};

socket.on("__replay", (d) => localStorage.setItem("_aid", d));

const sendData = async (user_id, time, ip_info) => {
  Obj.totalTime = time;
  Obj.network = ip_info;

  let a = {
    _aid: localStorage.getItem("_aid"),
    spend: time,
    _sid: socket.id,
  };

  // user &&
  socket.emit(
    "Activity",
    JSON.stringify({
      activity: a,
      data: {
        token: get("token"),
        page_title: document.title,
        page_path: window.location.pathname,
        total_time: time,
        site_id: process.env.REACT_APP_SITE_ID,
        user_id: user_id,
        ua: Obj,
        network: ip_info,
      },
    })
  );
};
const connectMainIo = () => {
  const socketConnection = socket.connect();
  socketConnection.on("connect", function () {
    const sessionID = socketConnection.id;
  });
};

// Single Client Data
// onclick Function tobe impliment
socket.on("LiveFeed", (data) => {
  socket.emit("ping", { rsid: socket.id, usid: "KH3Qmnc83akP_6i3AAAF" });
});

socket.on("listening", () => {
  socket.emit("replay", {
    data: {
      token: get("token"),
      page_title: document.title,
      page_path: window.location.pathname,
      // total_time: time,
      site_id: process.env.REACT_APP_SITE_ID,
      // user_id: user_id.uid,
      ua: Obj,
      network: network,
    },
  });
});

// END Single Client Data

export { connectMainIo, sendData, socket };
